export default function CustomPartsPanel() {
  return (
    <div data-testid="custom-parts-notice" className="p-7 rounded-sm border border-[#D946EF]/30 bg-gradient-to-br from-[#D946EF]/5 to-[#FF2D87]/5">
      <div className="text-xs tracking-[0.3em] text-[#D946EF] mb-3">CUSTOM PARTS · BY CONSULTATION</div>
      <h3 className="font-display font-bold text-2xl tracking-tight mb-3">
        Every build is one-of-one.
      </h3>
      <p className="text-zinc-300 text-sm font-body leading-relaxed mb-6">
        Custom Parts — digital cockpit retrofits, bespoke trim, illuminated badges, special
        fabrications — can't be priced from a dropdown. Get in touch with a quick brief of
        what you have in mind and we'll set up a free consultation, send a quote, and book
        you in once you're happy.
      </p>
      <div className="flex flex-wrap gap-3">
        <a
          href="https://wa.me/447538963090?text=Hi%20LAC%20%E2%80%94%20I%27d%20like%20a%20Custom%20Parts%20consultation."
          target="_blank"
          rel="noopener noreferrer"
          data-testid="custom-parts-whatsapp"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#25D366] text-black font-semibold text-sm hover:bg-[#1ebe57] transition"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor"><path d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.11.55 4.17 1.6 5.99L0 24l6.18-1.62A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.21-3.48-8.52ZM12 22a9.9 9.9 0 0 1-5.05-1.38l-.36-.21-3.67.96.98-3.58-.23-.37A9.93 9.93 0 1 1 22 12c0 5.52-4.48 10-10 10Zm5.45-7.45c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.93 1.17-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.67-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.34.46-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.2-.24-.58-.49-.5-.66-.51l-.56-.01c-.2 0-.51.07-.78.37-.27.3-1.02 1-1.02 2.44 0 1.43 1.04 2.82 1.18 3.02.15.2 2.04 3.12 4.94 4.38 2.9 1.26 2.9.84 3.42.79.52-.05 1.68-.69 1.92-1.36.24-.66.24-1.23.17-1.36-.07-.13-.27-.2-.57-.35Z"/></svg>
          WhatsApp 07538 963090
        </a>
        <a
          href="tel:+447538963090"
          data-testid="custom-parts-call"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#D946EF] text-white font-semibold text-sm hover:bg-[#F0ABFC] transition"
        >
          Call us
        </a>
        <a
          href="mailto:lac.ltd24@gmail.com?subject=Custom%20Parts%20consultation"
          data-testid="custom-parts-email"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/15 text-white hover:border-[#D946EF]/60 hover:text-[#D946EF] transition text-sm font-semibold"
        >
          Email us
        </a>
      </div>
      <div className="mt-6 pt-5 border-t border-white/10 text-xs text-zinc-500">
        Want a Starlight or Ambient install instead? Pick one of those above to book online.
      </div>
    </div>
  );
}
